/***Dependencies */
import React from "react";
import { Loader } from "../components/Loader";

/**Styles */

import { Currency } from "../helpers";
import { Col, Row } from "react-bootstrap";

/**
 * Componente principal que muestra el banner con carrusel, inputs de búsqueda y selector de habitaciones.
 * @param {array} imgsBanner - Arreglo de objetos con propiedades "image" que contienen la ruta de
 *                              las imágenes del carrusel.
 * @param {boolean} showSearch - Indica si se muestra el formulario de búsqueda o no.
 * @returns {React.Component} - Componente principal con el banner y los inputs de búsqueda.
 */
export const ErrorReserva = ({ showLoader }) => {
  return (
    <>
      <Row className="justify-content-center">
        {showLoader && <Loader />}
        <Col lg={12} className="d-flex justify-content-center">
          <img
            src={`https://panel.marzahtravel.com/assets/img/logoHeader.png`}
            alt=""
            className="h-auto"
            width={180}
          />
        </Col>
        <Col lg={12}>
          <h1 className="text-center">
            ¡LO SENTIMOS! <br />{" "}
            <span style={{ fontSize: "50px" }}>
              Ha ocurrido un error en la reserva
            </span>
          </h1>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #1763af",
          }}
          className=""
        />
        {/* <Col lg={12} className="mt-3 text-center">
        <h4>Numero de Transaccion: {idTransaccion}</h4>
      </Col> */}
        {/* <hr
        style={{
          width: "70%",
          margin: "0 auto",
          border: "3px solid #1763af"
        }}
        className="my-3"
      /> */}
        <Col lg={12} className="mt-3 text-center">
          <Row className="justify-content-center">
            {/* <Col
              style={{ borderRight: "1px solid black", textAlign: "end" }}
              lg={3}
            >
              <p>Total Pago</p>
            </Col>
            <Col lg={3} className="text-start">
              <p>{Currency(reserva?.totalPago) + " MXN"}</p>
            </Col> */}
          </Row>
          <p className="text-center">
            Si tienes dudas de tu reservación o deseas realizar algún cambio,
            comunícate al 998 218 9740 y uno de nuestros ejecutivos te brindará
            asistencia.
          </p>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #1763af",
          }}
          className="my-3"
        />
        <Col lg={12}>
          <p style={{ textAlign: "center" }}>
            Ocurrio un error con algunas de sus reservas, contáctanos para poder
            finalizar su reserva y resolver el problema.
          </p>

          <p style={{ textAlign: "center" }}>
            Contáctanos
            <br />
            998 218 9740 | info@marzahtravel.com
          </p>
          <p style={{ textAlign: "justify" }}>
            En Marzah Travel estamos comprometidos con tu seguridad. por ello,
            te informamos que de manera aleatoria nuestro departamento de
            protección de datos personales realiza una validación adicional y
            podrá solicitarse documentos que comprueben que eres el titular de
            la reservación y/o la compra es autorizada por el titular de la
            forma de pago que elegiste. En caso de no proveerla, tu reservación
            puede estar sujeta a la cancelación del servicio.
          </p>
          <p style={{ textAlign: "center", margin: "0" }}>
            © Marzah Travel. Todos los derechos reservados.
          </p>
        </Col>
      </Row>
    </>
  );
};
